import * as React from 'react';
import s from './OnlyIn.module.less';

type Props = { children: React.ReactNode };

const OnlyInDesktop = ({ children }: Props) => <div className={s.desktopOnly}>{children}</div>;

export default OnlyInDesktop;
